module.exports = __webpack_public_path__ + "img/icon-download-blue.8b530174.svg";